import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef, MatSort, MatTableDataSource, Sort} from "@angular/material";
import {MessageService} from "../../../core/services/message.service";
import {Usuario} from "../../../models/usuario";
import {UsuarioService} from "../../../services/usuario.service";
import {NgxSpinnerService} from "ngx-spinner";
import {ValidatorService} from "../../../core/services/validator.service";
import {Estado} from "../../../models/estado";
import {Municipio} from "../../../models/municipio";
import {EstadoService} from "../../../services/estado.service";
import {MunicipioService} from "../../../services/municipio.service";

@Component({
    selector: 'app-dialog-usuario-externo',
    templateUrl: './dialog-usuario-externo.component.html',
    styleUrls: ['./dialog-usuario-externo.component.scss']
})
export class DialogUsuarioExternoComponent implements OnInit {

    public form: FormGroup;

    public usuario: Usuario;
    public estados: Array<Estado>;
    public municipios: Array<Municipio>;

    constructor(public dialogRef: MatDialogRef<DialogUsuarioExternoComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any,
                private messageService: MessageService,
                private loadingService: NgxSpinnerService,
                private validator: ValidatorService,
                private estadoService: EstadoService,
                private municipioService: MunicipioService,
                private usuarioService: UsuarioService) {

    }

    ngOnInit() {
        this.dialogRef.disableClose = true;
        this.usuario = this.data.item;
        this.form = new FormGroup({
            cod_usuario: new FormControl(this.usuario.cod_usuario, []),
            txt_nome: new FormControl(this.usuario.txt_nome, [
                Validators.required,
            ]),
            num_cpf: new FormControl(this.usuario.num_cpf, [
                Validators.required,
                ValidatorService.cpf
            ]),
            cod_perfil: new FormControl(this.usuario.cod_perfil, []),
            num_telefone: new FormControl(this.usuario.num_telefone, [
                Validators.required,
                ValidatorService.telefone
            ]),
            txt_cargo: new FormControl(this.usuario.txt_cargo, [
                Validators.required
            ]),
            txt_orgao: new FormControl(this.usuario.txt_orgao, [
                Validators.required
            ]),
            txt_unidade: new FormControl(this.usuario.txt_unidade, [
                Validators.required
            ]),
            txt_situacao: new FormControl(this.usuario.txt_situacao, []),
            uf: new FormControl(this.usuario.txt_sigla_uf, [
                Validators.required
            ]),
            cod_municipio: new FormControl(null, [
                Validators.required
            ]),
            num_cnpj: new FormControl(null, [
                Validators.required,
                ValidatorService.cnpj
            ]),
            txt_nome_prefeito: new FormControl(null, [
                Validators.required
            ]),
            flg_externo: new FormControl(this.usuario.flg_externo, []),
            txt_email: new FormControl(this.usuario.txt_email, [
                Validators.required,
                Validators.email,
            ])
        });
        this.estados = [];
        this.municipios = [];
        this.estadoService.listAll().subscribe((estados: Array<Estado>) => {
            this.estados = estados;
        });

        this.municipioService.listAll(this.usuario.txt_sigla_uf).subscribe((municipios: Array<Municipio>) => {
            this.municipios = municipios;
        });
        this.form.patchValue({
            cod_usuario: this.usuario.cod_usuario,
            cod_perfil: this.usuario.cod_perfil,
            txt_nome: this.usuario.txt_nome,
            num_cpf: this.usuario.num_cpf,
            txt_email: this.usuario.txt_email,
            uf: this.usuario.txt_sigla_uf,
            num_telefone: this.usuario.num_telefone,
            cod_municipio: this.usuario.cod_municipio,
            txt_cargo: this.usuario.txt_cargo,
            txt_orgao: this.usuario.txt_orgao,
            txt_unidade: this.usuario.txt_unidade,
            num_cnpj: this.usuario.num_cnpj,
            txt_nome_prefeito: this.usuario.txt_nome_prefeito,
            flg_externo: this.usuario.flg_externo
        });

    }

    close(salvar: boolean = false): void {
        this.dialogRef.close({salvar: salvar});
    }

    carregarEstados(): void {
        this.loadingService.show();
        this.estados = [];
        this.estadoService.listAll().subscribe((estados: Array<Estado>) => {
            this.estados = estados;
            this.loadingService.hide();
        }, () => {
            this.loadingService.hide();
        });
        this.form.patchValue({
            cod_municipio: null
        });
    }

    carregarMunicipios(uf: string): void {
        this.municipios = [];
        if (uf) {
            this.loadingService.show();
            this.municipioService.listAll(uf).subscribe((municipios: Array<Municipio>) => {
                this.municipios = municipios;
                this.loadingService.hide();
            }, () => {
                this.loadingService.hide();
            });
        }
    }

    save(): void {
        this.form.markAsTouched();
        if (this.form.valid) {
            let form = this.form.value as Usuario;
            this.usuarioService.saveExterno(form).subscribe((data: any) => {
                if (form.cod_usuario) {
                    this.close(true);
                } else {
                    this.messageService.showSuccess(data.message);
                }
            }, (error) => {
                this.loadingService.hide();
                this.messageService.showResponseError(error);
            });
        }
    }
}